export const replaceHostInUrl = (
  link: string = "",
  nextHost: string
): string => {
  const trimmedLink = link.trim();
  if (!trimmedLink) {
    return trimmedLink;
  }
  const url = new URL(trimmedLink);
  url.host = nextHost;
  return url.toString();
};
